import { Dayjs } from 'dayjs';
import React from 'react';

interface CardLicenseDetailsProps {
  startDate: Dayjs;
  endDate: Dayjs;
  type: number;
  dataTour?: string;
}

const CardLicenseDetails = (props: CardLicenseDetailsProps): JSX.Element => {
  return (
    <>
      <div data-tour={props.dataTour}>
        <div className="flex flex-row gap-4 mt-4 w-full">
          <div className="flex flex-col gap-1 w-1/2">
            <p className="left text-left">Start Date</p>
            <p className="right text-left">{props.startDate.format('LLL')}</p>
          </div>
          <div className="flex flex-col gap-1 w-1/2">
            <p className="left text-left">End Date</p>
            <p className="right text-left">{props.endDate.format('LLL')}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardLicenseDetails;
